import PropTypes from 'prop-types'

// material-ui
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import ListApp from 'components/ListApp'
// project imports
import LogoSection from '../LogoSection'
import ProfileSection from './ProfileSection'

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme()

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          },
          gap: 2
        }}
      >
        <ListApp />
        <Box sx={{ display: { xs: 'none', md: 'flex' }, flexGrow: 1, justifyContent: 'center' }}>
          <LogoSection />
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <ProfileSection />
    </>
  )
}

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
}

export default Header
